module.exports = __webpack_public_path__ + "static/media/studio-etc14.a13f973a.png";